module.exports = __webpack_public_path__ + "2a44fa3bbe4b9c22c30f77a3aa949c63.png";